import useLogout from "common/auth/hooks/use-logout";
import { Card } from "components/card";
import PageWrapper from "components/page-wrapper";
import { useIntercom } from "react-use-intercom";

import css from "./index.module.scss";

export const PaymentInReviewPage = () => {
  const logout = useLogout();
  const { showNewMessage } = useIntercom();

  return (
    <PageWrapper centerVertically maxWidth={640} title="Verification Required">
      <Card className={css.content}>
        <h3 className={css.title}>Verification Required</h3>
        <p className={css.subtitle}>
          <strong>
            We've temporarily paused your account while we verify a recent
            payment.
          </strong>
          <br />
          Most reviews complete within 24 hours.
        </p>
        <p>
          <strong>To restore access</strong>, please email{" "}
          <a href="mailto:apizzini@anymailfinder.com">
            apizzini@anymailfinder.com
          </a>{" "}
          with:
        </p>
        <ul>
          <li>
            A photo of your government-issued ID (front only), or the passport
            photo page.
          </li>
          <li>
            Proof of payment - either:
            <ul>
              <li>
                A photo of the card showing only your name and last 4 digits
                (cover the rest; do not include CVV or the back), or
              </li>
              <li>
                A bank/app screenshot of the charge (amount, date, and last 4
                digits are enough).
              </li>
            </ul>
          </li>
        </ul>

        <p>Once we review your documents, we'll reactivate your account.</p>
        <div className={css.note}>
          <a onClick={() => showNewMessage()}>Contact support</a> or{" "}
          <a onClick={() => logout()}>Logout</a>.
        </div>
      </Card>
    </PageWrapper>
  );
};
